// 导入样式文件
import './Assets.less';
// 导入React hooks
import { useState, useEffect, useRef, useCallback } from 'react';
// 导入日期格式化工具函数
import { formatMilliseconds, timeDiffFromNow } from '@/utils/dayjs';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';
// 导入资源图片
import slideFile from '@/assets/assets/slide-file.png';
import Video from '@/assets/assets/video.png';
import { useDashboardData } from '@/hooks/DashboardHooks';

import { assetController } from '@/api/index';

import Upload from '@/components/upload/Upload';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import { CheckEquity } from '@/utils/CheckEquity';
import { useDrawer } from '@/hooks/DrawerHooks';
import { useTranslation } from 'react-i18next';
// 定义Assets组件
export default function Assets() {
  const { t } = useTranslation();
  // 定义当前激活的标签状态
  const [tabActive, setTabActive] = useState('video');
  // 定义列表数据状态
  const [videoList, setVideoList] = useState([]);
  // 定义列表数据状态
  const [slideList, setSlideList] = useState([]);
  const { setChildCallback, userData } = useDashboardData();
  const [uploadPupUpModal, setUploadPupUpModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setIsSubscribeOpen } = useDrawer();
  useEffect(() => {
    getList();
  }, []);

  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(() => {
      getList();
    }, []),
  );
  const getList = async () => {
    setLoading(true);
    try {
      const res = await assetController.assetsList();
      if (res?.code === 0) {
        res.data.videos ||
          [].filter((item) => {
            item.isOpen = false;
            item.editShow = false;
          });
        res.data.slices ||
          [].filter((item) => {
            item.isOpen = false;
            item.editShow = false;
          });
        setVideoList(res.data.videos);
        setSlideList(res.data.slices);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useWebSocket(
    MessageEventType.USER_ASSET_DETAILS,
    useCallback(
      ({ assetId, details }) => {
        const updatedSlideList = slideList.map((slide) => {
          if (slide.id === assetId) {
            return {
              ...slide,
              status: 1,
              thumbnail: details[0].url,
            };
          }
          return slide;
        });
        setSlideList(updatedSlideList);
      },
      [slideList],
    ),
  );
  // 处理标签切换的函数
  const handleTabChange = (val) => {
    setTabActive(val);
  };
  const onUploadSuccess = async (val, file) => {
    console.log('父组件接收val', val);
    await assetController.add({
      name: file.name,
      uploadId: val.uploadId,
      completedParts: val.eTags,
    });
    setChildCallback(new Date().getTime());
    getList();
  };
  const handleUpload = () => {
    if (!CheckEquity({ userData, type: 'storage' })) {
      // setIsOpen(true);
      setIsSubscribeOpen('open');
      return;
    }
    setUploadPupUpModal(true);
  };
  const videoAccept = {
    accept: '.mp4',
    text: 'As_CreateProjectRewrite_LocalDes3',
    maxSize: 1024 * 1024 * 1024, // 1GB
    type: 'assets_videos',
  };
  const slideAccept = {
    accept: '.ppt,.pptx,.pdf',
    text: 'As_Remind_LocalDes1',
    maxSize: 500 * 1024 * 1024, // 200M
    type: 'assets_slides',
  };
  const acceptType = () => (tabActive === 'video' ? videoAccept : slideAccept);
  return (
    <>
      {loading ? (
        <div className="loading_main">
          <span className="loading loading-spinner loading-md text-neutral"></span>
        </div>
      ) : (
        <div className="assets_box">
          <Upload
            value={{
              uploadPupUpModal,
              setUploadPupUpModal,
              onUploadSuccess,
              accept: acceptType().accept,
              text: acceptType().text,
              maxSize: acceptType().maxSize,
              type: acceptType().type,
              usage: 4,
            }}
          />
          <div className="assets_title">
            {/* My Assets */}
            {t('As_Recording_Assets1')}
          </div>
          <div className="assets_tab_box">
            <div className="tab_box">
              {/* 视频标签按钮 */}
              <button
                onClick={() => {
                  handleTabChange('video');
                }}
                className={`btn btn-ghost tabitem ${tabActive === 'video' ? 'tabitem_active' : ''}`}>
                {/* Videos */}
                {t('As_Recording_Assets2')}
              </button>
              {/* 幻灯片标签按钮 */}
              <button
                onClick={() => {
                  handleTabChange('slides');
                }}
                className={`btn btn-ghost tabitem ${tabActive === 'slides' ? 'tabitem_active' : ''}`}>
                {/* Slides */}
                {t('As_Recording_Assets3')}
              </button>
            </div>
            <div className="upload_box">
              {/* 上传视频按钮 */}
              <button className="btn btn-primary upload_btn btn-sm" onClick={handleUpload}>
                {/* {tabActive === 'video' ? 'Upload video' : 'Upload slide'} */}
                {tabActive === 'video'
                  ? t('As_CreateProjectTrans_LocalTitle')
                  : t('As_Recording_UploadSlides')}

                <Icon name="icon-upload" className="upload_icon" />
              </button>
            </div>
          </div>
          {/* 资源列表内容 */}
          <div>
            {tabActive === 'video' ? (
              <AssetsVideo list={videoList} assetsList={getList} />
            ) : (
              <AssetsSlides list={slideList} assetsList={getList} />
            )}
          </div>
        </div>
      )}
    </>
  );
}

// 视频资源组件
function AssetsVideo({ list, assetsList }) {
  return (
    <div className="assets_list_content">
      {list?.length > 0 ? (
        list.map((item, index) => (
          <ItemCard type="video" key={index} item={item} assetsList={assetsList} />
        ))
      ) : (
        <EmptyAssets text="As_Remind_LocalDes2" />
      )}
    </div>
  );
}

// 幻灯片资源组件
function AssetsSlides({ list, assetsList }) {
  return (
    <div className="assets_list_content">
      {list?.length > 0 ? (
        list.map((item, index) => (
          <ItemCard type="slides" key={index} item={item} assetsList={assetsList} />
        ))
      ) : (
        <EmptyAssets text="As_Remind_LocalDes3" />
      )}
    </div>
  );
}

// 资源项卡片组件
function ItemCard({ type, item, assetsList }) {
  const [itemData, setItemData] = useState(JSON.parse(JSON.stringify(item)));
  const inputRef = useRef(null);
  const PopUpRef = useRef(null);
  const [previewImgList, setPreviewImgList] = useState([]);
  const [previewImgIndex, setPreviewImgIndex] = useState(1);
  const { setChildCallback } = useDashboardData();
  const { t } = useTranslation();
  useEffect(() => {
    setItemData(JSON.parse(JSON.stringify(item)));
  }, [item]);
  const itemCardStatus = () => {
    if (item.status > 0) return;
    if (type === 'slides') {
      return (
        <div className="option_edit">
          <div className="text">
            <img className="text_img" src={slideFile} alt="" />
            <div className="spot_box">
              {/* Processing to slides */}
              {t('As_Home_ProjectState1')}
              <span className="spot_list">
                <span className="spot">·</span>
                <span className="spot">·</span>
                <span className="spot">·</span>
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="option_edit">
          <div className="text1">
            {/* Processing to slides... */}
            {t('As_Home_ProjectState1')}...
          </div>
        </div>
      );
    }
  };

  const handleDelete = async () => {
    await assetController.delete({ assetId: item.id });
    assetsList();
    setChildCallback(new Date().getTime());
  };

  const handleEditName = () => {
    setItemData((prev) => ({ ...prev, editShow: true }));
    mouseLeaveClose();
  };

  const mouseLeaveClose = () => {
    setItemData((prev) => ({ ...prev, isOpen: false }));
  };

  const mouseHoverShow = () => {
    setItemData((prev) => ({ ...prev, isOpen: true }));
  };

  const handleChangeName = (e) => {
    setItemData((prev) => ({ ...prev, name: e.target.value }));
  };

  const handleEditEnd = async () => {
    if (!itemData.name) {
      setItemData((prev) => ({ ...prev, editShow: false }));
      assetsList();
      return;
    }
    await assetController.rename({
      assetId: item.id,
      body: {
        newName: itemData.name,
      },
    });
    assetsList();
  };

  useEffect(() => {
    if (itemData.editShow && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemData.editShow]);
  useEffect(() => {
    // 监听 dialog 关闭事件
    const handleDialogClose = () => {
      if (type === 'video') {
        console.log('关闭了');
        const video = PopUpRef.current?.querySelector('video');
        if (video) {
          video.pause();
        }
      }
    };

    const dialogElement = PopUpRef.current;
    dialogElement?.addEventListener('close', handleDialogClose);

    return () => {
      dialogElement?.removeEventListener('close', handleDialogClose);
    };
  }, [type]);

  const VideoPupUp = () => {
    if (type === 'video') {
      return (
        <dialog id="my_modal_2" ref={PopUpRef} className="modal">
          <div className="modal-box min-w-[960px]">
            <video src={itemData.url} controls></video>
          </div>
          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      );
    } else {
      return (
        <dialog id="my_modal_2" ref={PopUpRef} className="modal ppt_modal">
          <div className="modal-box min-w-[960px]">
            <div className="ppt_img">
              <img src={previewImgList[previewImgIndex - 1]?.url} alt="" />
            </div>
            <div className="ppt_btn">
              <button onClick={handleFirst} className="btn btn-secondary btn-sm">
                <Icon name="icon-to-left" />
              </button>
              <button onClick={handlePrev} className="btn btn-secondary btn-sm ml-[20px]">
                <Icon name="icon-arrow-left" />
              </button>
              <div className="pagination_box">
                {previewImgIndex}/{previewImgList?.length}
              </div>
              <button onClick={handleNext} className="btn btn-secondary btn-sm mr-[20px]">
                <Icon name="icon-arrow-right" />
              </button>
              <button onClick={handleLast} className="btn btn-secondary btn-sm">
                <Icon name="icon-to-right" />
              </button>
            </div>
          </div>

          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      );
    }
  };

  const handleFirst = () => {
    setPreviewImgIndex(1);
  };

  const handlePrev = () => {
    if (previewImgIndex <= 1) {
      setPreviewImgIndex(1);
    } else {
      setPreviewImgIndex(previewImgIndex - 1);
    }
  };

  const handleNext = () => {
    if (previewImgIndex >= previewImgList?.length) {
      setPreviewImgIndex(previewImgList?.length);
    } else {
      setPreviewImgIndex(previewImgIndex + 1);
    }
  };

  const handleLast = () => {
    setPreviewImgIndex(previewImgList?.length);
  };

  const handlePreview = async () => {
    if (item.status <= 0) {
      return;
    }
    const res = await assetController.detail({ assetId: item.id });
    if (res.code === 0) {
      setPreviewImgList(res.data);
    }
    PopUpRef.current.show();
  };

  return (
    <div className="project_item">
      <div className="top">
        {type === 'video' ? (
          <video
            className="project_img"
            src={itemData.url}
            preload="metadata"
            onLoadedMetadata={(e) => {
              const duration = e.target.duration;
              setItemData((prev) => ({ ...prev, duration }));
            }}
          />
        ) : (
          <img className="project_img" src={itemData.thumbnail} alt="" />
        )}
        {type === 'video' && (
          <div className="options_box">{formatMilliseconds((itemData.duration || 0) * 1000)}</div>
        )}
        {itemData.status !== 0 && (
          <div className="preview_box" onClick={handlePreview}>
            <Icon name="icon-view" className="preview_icon" />
            {/* Preview */}
            {t('As_ProjectManage_PreviewView')}
          </div>
        )}
        {itemCardStatus()}
      </div>
      <div className="btm">
        <div className="project_information">
          <div className="project_name">
            {itemData.editShow ? (
              <input
                ref={inputRef}
                type="text"
                defaultValue={itemData.name}
                onChange={handleChangeName}
                onBlur={handleEditEnd}
                maxLength={200}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.target.blur();
                  }
                }}
                placeholder=""
                className="input input-bordered w-full input-xs"
              />
            ) : (
              <div className="show_name">{itemData.name}</div>
            )}
          </div>
          <div className="last_time">Last updated {timeDiffFromNow(itemData.gmtModified)}</div>
        </div>
        <div
          className="dropdown dropdown-left dropdown-open"
          id={`dropdown-${itemData.id}`}
          onMouseEnter={() => mouseHoverShow()}
          onMouseLeave={() => mouseLeaveClose()}>
          <Icon tabIndex={0} name="icon-dot-more-vertically" className="right_more" />
          {itemData.isOpen && (
            <ul
              tabIndex={0}
              onMouseLeave={() => mouseLeaveClose()}
              className="dropdown-content menu bg-base-100 rounded-box z-[3] w-52 p-2 shadow">
              {item.status > 0 && (
                <li onClick={handlePreview}>
                  <a className="drop_item">
                    <Icon name="icon-view" className="drop_icon" />
                    {/* Preview */}
                    {t('As_ProjectManage_PreviewView')}
                  </a>
                </li>
              )}
              <li onClick={handleEditName}>
                <a className="drop_item">
                  <Icon name="icon-edit" className="drop_icon" />
                  {/* Rename */}
                  {t('As_ProjectManage_Rename')}
                </a>
              </li>
              <li onClick={handleDelete}>
                <a className="drop_item">
                  <Icon name="icon-delete" className="drop_icon" />
                  {/* Delete */}
                  {t('As_ProjectManage_Delete')}
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
      {VideoPupUp()}
    </div>
  );
}

// 空资源显示组件
function EmptyAssets({ text }) {
  const { t } = useTranslation();
  return (
    <div className="empty_assets">
      <img className="empty_img" src={Video} alt="" />
      <div className="text">{t(text)}</div>
    </div>
  );
}
